import { api } from '../components';
import {
  DeregisterIntent,
  DeregisterInterest,
  GetLaunchConfig,
  GetLaunchConfigResp,
  LaunchPwa,
  ListPwas,
  ListPwasResponse,
  NotifyInterest,
  RaiseIntent,
  RegisterIntent,
  RegisterInterest,
  subjects,
  SynergyMessage,
  LaunchConfig,
  Pwa,
} from '../types/';
import { connect, sendMessage } from './socket';
import { guid } from './utlis';
export type InterestUpdate<T> = (
  topic: string,
  interest: T,
  domain: string,
  subDomain: string,
) => void;
export type IntentAction<T> = (
  action: string,
  payload: T,
  domain: string,
  subDomain: string,
) => void;

interface RegisteredInterest {
  topic: string;
  domain?: string;
  subDomain?: string;
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  callbacks: InterestUpdate<any>[];
}
interface RegisteredIntent {
  action: string;
  domain?: string;
  subDomain?: string;
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  callbacks: IntentAction<any>[];
}
interface GetAppRequest {
  id: string;
  resolve: (value: Pwa[] | PromiseLike<Pwa[]>) => void;
}
interface GetLaunchConfigRequest {
  id: string;
  resolve: (value: LaunchConfig | PromiseLike<LaunchConfig>) => void;
}

const registeredInterests: RegisteredInterest[] = [];
const registeredIntents: RegisteredIntent[] = [];
const getAppsRequests = new Map<string, GetAppRequest>();
const getLaunchConfigRequests = new Map<string, GetLaunchConfigRequest>();

const interestMatch = (registered: RegisteredInterest, nofify: NotifyInterest): boolean => {
  console.log(registered);
  console.log(nofify);
  return (
    (!registered.domain || registered.domain === nofify.domain) &&
    (!registered.subDomain || registered.subDomain === nofify.subDomain) &&
    registered.topic === nofify.topic
  );
};

const intentMatch = (registered: RegisteredIntent, nofify: RaiseIntent): boolean => {
  return (
    (!registered.domain || registered.domain === nofify.domain) &&
    (!registered.subDomain || registered.subDomain === nofify.subDomain) &&
    registered.action === nofify.action
  );
};

export const handleMessage = (message: SynergyMessage) => {
  console.log('synergyMessage recieved:');
  console.log(message);
  try {
    switch (message.subject) {
      case subjects.NOTIFY_INTEREST: {
        const notifyInterest = message as NotifyInterest;
        console.log(registeredInterests);
        registeredInterests
          .filter((interest) => interestMatch(interest, notifyInterest))
          .forEach((interest) => {
            console.log('Sending to client');
            interest.callbacks.forEach((callback) =>
              callback(
                notifyInterest.topic,
                notifyInterest.interest,
                notifyInterest.domain,
                notifyInterest.subDomain,
              ),
            );
          });
        break;
      }

      case subjects.RAISE_INTENT: {
        const raiseIntent = message as RaiseIntent;
        registeredIntents
          .filter((intent) => intentMatch(intent, raiseIntent))
          .forEach((interest) => {
            interest.callbacks.forEach((callback) =>
              callback(
                raiseIntent.action,
                raiseIntent.payload,
                raiseIntent.domain,
                raiseIntent.subDomain,
              ),
            );
          });
        break;
      }

      case subjects.LIST_PWAS_RESP: {
        const ListPwasResponse = message as ListPwasResponse;
        if (getAppsRequests.has(ListPwasResponse.id)) {
          const request = getAppsRequests.get(ListPwasResponse.id);
          if (request) {
            request.resolve(ListPwasResponse.pwaList);
            getAppsRequests.delete(ListPwasResponse.id);
          }
        }
        break;
      }

      case subjects.GET_LAUNCH_CONFIG_RESP: {
        const getLaunchConfigResp = message as GetLaunchConfigResp;

        if (getLaunchConfigRequests.has(getLaunchConfigResp.id)) {
          const request = getLaunchConfigRequests.get(getLaunchConfigResp.id);
          if (request) {
            const launchConfig: LaunchConfig = {
              pwas: getLaunchConfigResp.launchConfig.pwas,
              lists: new Map(Object.entries(getLaunchConfigResp.launchConfig.lists)),
              choices: getLaunchConfigResp.launchConfig.choices,
              interests: getLaunchConfigResp.launchConfig.interests,
              intents: getLaunchConfigResp.launchConfig.intents,
            };
            request.resolve(launchConfig);
            getLaunchConfigRequests.delete(getLaunchConfigResp.id);
          }
        }
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export const connectionUp = () => {
  console.log('Registering interests and intents');
  registeredInterests.forEach((interest) => {
    const registerInterest: RegisterInterest = {
      subject: 'REGISTER_INTEREST',
      topic: interest.topic,
      domain: interest.domain,
      subDomain: interest.subDomain,
    };
    sendMessage(registerInterest);
  });
  registeredIntents.forEach((intent) => {
    const registerIntent: RegisterIntent = {
      subject: 'REGISTER_INTENT',
      action: intent.action,
      domain: intent.domain,
      subDomain: intent.subDomain,
    };
    sendMessage(registerIntent);
  });
};

export const registerInterest = <T>(
  topic: string,
  callback: InterestUpdate<T>,
  domain?: string,
  subDomain?: string,
) => {
  const registeredInterest = registeredInterests.find(
    (registered) =>
      registered.topic === topic &&
      registered.domain === domain &&
      registered.subDomain === subDomain,
  );
  if (registeredInterest) {
    if (!registeredInterest.callbacks.includes(callback)) {
      //if interested has been registered but not the callback, then add it the list
      registeredInterest.callbacks.push(callback);
    }
  } else {
    //otherwise register interest
    registeredInterests.push({
      topic,
      domain,
      subDomain,
      callbacks: [callback],
    });
  }
  setTimeout(() => {
    const registerInterest: RegisterInterest = {
      subject: 'REGISTER_INTEREST',
      topic,
      domain,
      subDomain,
    };
    sendMessage(registerInterest);
  }, 1);
};

export const deregisterInterest = <T>(
  topic: string,
  callback: InterestUpdate<T>,
  domain?: string,
  subDomain?: string,
) => {
  console.log('deregistering interest');
  const registeredInterest = registeredInterests.find(
    (registered) =>
      registered.topic === topic &&
      registered.domain === domain &&
      registered.subDomain === subDomain,
  );
  if (registeredInterest) {
    if (registeredInterest.callbacks.length > 1) {
      const idx = registeredInterest.callbacks.indexOf(callback);
      registeredInterest.callbacks.splice(idx, 1);
    } else {
      const idx = registeredInterests.indexOf(registeredInterest);
      if (idx !== -1) {
        registeredInterests.splice(idx, 1);
      }
    }
  }
  const deregisterInterest: DeregisterInterest = {
    subject: 'DEREGISTER_INTEREST',
    topic,
    domain,
    subDomain,
  };
  sendMessage(deregisterInterest);
};

export const notifyInterest = (
  topic: string,
  domain: string | undefined,
  subDomain: string | undefined,
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  interest: any,
) => {
  const notifyInterest: NotifyInterest = {
    subject: 'NOTIFY_INTEREST',
    topic,
    domain: domain ?? '',
    subDomain: subDomain ?? '',
    interest,
  };
  sendMessage(notifyInterest);
};

export const registerIntent = <T>(
  action: string,
  callback: IntentAction<T>,
  domain?: string,
  subDomain?: string,
) => {
  const RegisteredIntent = registeredIntents.find(
    (registered) =>
      registered.action === action &&
      registered.domain === domain &&
      registered.subDomain === subDomain,
  );
  if (RegisteredIntent) {
    if (!RegisteredIntent.callbacks.includes(callback)) {
      //if intent has been registered but not the callback, then add it the list
      RegisteredIntent.callbacks.push(callback);
    }
  } else {
    //otherwise register intent
    registeredIntents.push({
      action,
      domain,
      subDomain,
      callbacks: [callback],
    });
  }
  setTimeout(() => {
    const registerIntent: RegisterIntent = {
      subject: 'REGISTER_INTENT',
      action,
      domain,
      subDomain,
    };
    sendMessage(registerIntent);
  }, 1);
};

export const deregisterIntent = <T>(
  action: string,
  callback: IntentAction<T>,
  domain?: string,
  subDomain?: string,
) => {
  const registeredIntent = registeredIntents.find(
    (registered) =>
      registered.action === action &&
      registered.domain === domain &&
      registered.subDomain === subDomain,
  );
  if (registeredIntent) {
    if (registeredIntent.callbacks.length > 1) {
      const idx = registeredIntent.callbacks.indexOf(callback);
      registeredIntent.callbacks.splice(idx, 1);
    } else {
      const idx = registeredIntents.indexOf(registeredIntent);
      if (idx !== -1) {
        registeredIntents.splice(idx, 1);
      }
    }
  }
  const deregisterIntent: DeregisterIntent = {
    subject: 'DEREGISTER_INTENT',
    action,
    domain,
    subDomain,
  };
  sendMessage(deregisterIntent);
};

export const raiseIntent = (
  action: string,
  domain: string | undefined,
  subDomain: string | undefined,
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  payload: any,
) => {
  const raiseIntent: RaiseIntent = {
    subject: 'RAISE_INTENT',
    domain: domain ?? '',
    subDomain: subDomain ?? '',
    action,
    payload,
  };
  sendMessage(raiseIntent);
};

export const getApps = (filter: string): Promise<Pwa[]> => {
  return new Promise<Pwa[]>((resolve, reject) => {
    try {
      const id = guid();
      getAppsRequests.set(id, {
        id,
        resolve,
      });
      const listPwas: ListPwas = {
        subject: 'LIST_PWAS',
        id,
        filter,
      };
      sendMessage(listPwas);
    } catch (error) {
      reject(error);
    }
  });
};

export const launchPwa = (url: string): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    try {
      const launchPwa: LaunchPwa = {
        subject: 'LAUNCH_PWA',
        url,
      };
      sendMessage(launchPwa);
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

export const getLaunchConfig = (): Promise<LaunchConfig> => {
  return new Promise<LaunchConfig>((resolve, reject) => {
    try {
      const id = guid();
      getLaunchConfigRequests.set(id, {
        id,
        resolve,
      });
      const getLaunchConfig: GetLaunchConfig = {
        subject: 'GET_LAUNCH_CONFIG',
        id,
      };
      sendMessage(getLaunchConfig);
    } catch (error) {
      reject(error);
    }
  });
};

if (!api.isMobile()) {
  console.log('Connecting to agent');
  connect();
} else {
  console.log('Mobile platform - not connecting');
}
